"use client";

import { FormContainer } from "@app/sdc/minicurso/components/MinicursoForm/styles";
import styled from "styled-components";

export const CertificadoFormContainer = styled(FormContainer)`
  margin: 1.5rem auto;
`;
